import { render, staticRenderFns } from "./AddOrEditPollutant.vue?vue&type=template&id=d863eca0&scoped=true&"
import script from "./AddOrEditPollutant.vue?vue&type=script&lang=js&"
export * from "./AddOrEditPollutant.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditPollutant.vue?vue&type=style&index=0&id=d863eca0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d863eca0",
  null
  
)

export default component.exports